// extracted by mini-css-extract-plugin
export default {"tabWrapper":"physician_tabWrapper__dVPSq","tabContent":"physician_tabContent__aZaEI","tabContentActive":"physician_tabContentActive__K39iq"};